export default "__VITE_ASSET__DN5x2kQ9__"